import { registerQuery } from 'data-fetching-client';
import * as ApiRoutes from 'automation-ui-canvas/data/api/ApiRoutes';
import http from 'hub-http/clients/apiClient';
export const SIMULATE_FLOW_QUERY_FIELDNAME = 'simulateFlow';
export const SIMULATE_FLOW_QUERY = registerQuery({
  fieldName: SIMULATE_FLOW_QUERY_FIELDNAME,
  args: ['flowId', 'objectId', 'branchOverrides', 'enrollType', 'sendEmailsToUser'],
  fetcher: ({
    flowId,
    objectId,
    branchOverrides,
    enrollType,
    sendEmailsToUser
  }) => {
    return http.post(`${ApiRoutes.FLOWS_SIMULATE_DYNAMIC_LOGS}/${flowId}/${objectId}`, {
      data: {
        enrollType,
        branchOverrides,
        sendEmailsToUser
      }
    });
  }
});